// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React from 'react';
import { Stepper, Step, StepLabel } from '@mui/material';
import { useTheme } from '@mui/system';
import { styled } from '@mui/material/styles';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { awProgressGreen } from 'Utils/themes';
import { PROJECT_PROGRESS_STEPS } from 'Utils/projectProgress';
import ColorlibStepIcon from './StepIcon';
import stylesDef from './styles';

interface IProjectProgressStepperProps {
  // How far through the pipeline the work is - selectProjectInfo's activeStep, the reading
  // every surface shares. The caller decides whether the bar is shown at all (isInProgress).
  activeStep: number;
}

const ColorlibConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 8,
    left: 'calc(-50% + 0px)',
    right: 'calc(50% + 0px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: awProgressGreen,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: awProgressGreen,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 4,
    border: 0,
    backgroundColor: '#797979',
    borderRadius: 1,
    width: '100%',
  },
}));

// AUT-6432: how far through Processing, AI and QC a project is, over the grid card's darkened
// image. The only surface that draws the pipeline - the list rows and the map's cards name the
// stage in their status chip instead, having no image to draw it on.
export const ProjectProgressStepper = ({ activeStep }: IProjectProgressStepperProps) => {
  const theme = useTheme();
  const styles = stylesDef(theme);

  return (
    <Stepper sx={styles.stepper} activeStep={activeStep} alternativeLabel connector={<ColorlibConnector />}>
      {PROJECT_PROGRESS_STEPS.map((label) => (
        <Step key={label}>
          <StepLabel StepIconComponent={ColorlibStepIcon} sx={styles.stepLabel}>
            {label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

export default ProjectProgressStepper;
